export const getDiscoverResults = (entity, searchType) => {
    let url = `/tools/google-discover-entity?s=${entity}&limit=100&indent=True`;
    if (searchType == 'id') url = url + '&method=kgid';
    return fetch(url);
};

export const createQuery = (data) => {
    return fetch('/api/v1/ai-prompts/?skip_existing_prompts=true', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
};

export const updateQuery = (id, data) => {
    return fetch(`/api/v1/ai-prompts/${id}/`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
};

export const getProjects = (include_disabled = false) => {
    return fetch(`/api/v1/tracking-projects/?include_disabled=${include_disabled}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
};

export const getCredits = () => {
    return fetch('/api/v1/user-credits/', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
};

export const createProjects = (data) => {
    return fetch('/api/v1/tracking-projects/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
};
